export default __webpack_public_path__ + "static/media/SEA_8397.ca582663.jpg";